import {Sync as SyncIcon} from '@mui/icons-material';
import PropTypes from 'prop-types';

import {BREAKPOINTS} from '../../../../const';
import useBreakpoint from '../../../../hooks/dom/useBreakpoint';
import Button from '../../../form/buttons/Button/Button';

const ActualizeAllSourcesButton = ({disabled, onClick}) => {
  const currentBreakpoint = useBreakpoint();
  const isExtraSmallScreen = currentBreakpoint === BREAKPOINTS.xs;

  return (
    <Button
      startIcon={isExtraSmallScreen ? null : <SyncIcon />}
      size="small"
      disabled={disabled}
      variant="contained"
      color="primary"
      onClick={onClick}
      sx={{
        fontSize: {
          xs: 10,
          sm: 12
        }
      }}
    >
      Actualiser les sources
    </Button>
  );
};

ActualizeAllSourcesButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ActualizeAllSourcesButton;
